import { FC, useEffect, useRef, useState, CSSProperties } from 'react'
import Hammer from 'hammerjs'
import { noop } from 'lodash'
import { defaultColorScheme } from '../helpers/color_scheme_helpers'
import SVGIcon from '../components/SVGIcon'
import { ColorScheme } from '@app-types/entity_types'

type CloseButtonProps = {
  x?: number
  y?: number
  rotation?: number
  opacity?: number
  zIndex?: number
  onTap?: (event: HammerInput) => void
  colorScheme: ColorScheme
}

const CloseButton: FC<CloseButtonProps> = ({
  x = 0,
  y = 0,
  rotation = 0,
  opacity = 1,
  zIndex = 1,
  onTap = noop,
  colorScheme = defaultColorScheme(),
}) => {
  const [mouseOver, setMouseOver] = useState(false)
  const buttonRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!buttonRef.current) return

    const hammerManager = new Hammer.Manager(buttonRef.current, {
      recognizers: [[Hammer.Tap]],
    })

    hammerManager.on('tap', onTap)

    return () => {
      hammerManager.off('tap')
      hammerManager.destroy()
    }
  }, [onTap])

  const handleMouseEnter = () => setMouseOver(true)
  const handleMouseLeave = () => setMouseOver(false)

  const style: CSSProperties = {
    position: 'absolute',
    top: y,
    left: x,
    zIndex,
    opacity,
    transform: `rotate(${rotation}deg)`,
    backgroundColor: colorScheme.secondary,
    color: mouseOver ? colorScheme.highlight : colorScheme.tertiary,
    ...(opacity <= 0 && { width: 0, height: 0 }),
  }

  return (
    <div
      ref={buttonRef}
      className="close-button"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={style}
      title="Close"
    >
      {opacity > 0 && <SVGIcon xlinkHref="#streamline-delete-1" alt="Close" pointerEvents="none" />}
    </div>
  )
}

export default CloseButton
